import Fast from './fast.webp';
import Gazebo from './gazebo.webp';
import L1 from './l1.webp';

export default {
    Fast,
    Gazebo,
    L1
}